import OrdersTable from 'pages/MyOrdersPage/ExternalOrders/OrdersTable/OrdersTable';

export default OrdersTable;
